/**
 * i18n configuration — react-i18next + i18next
 *
 * Currently English-only. To add a new language:
 *   1. Copy en.json → {lang}.json and translate
 *   2. Import and add to `resources` below
 *   3. Add a language switcher in settings
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes
  },
});

export default i18n;
